module.exports = __webpack_public_path__ + "static/media/jeff1.e42472f1.jpg";